// extracted by mini-css-extract-plugin
export default {"productGallery":"oM-z","inQuickShop":"pM-z"};